import { FC, ReactElement, useState } from 'react'

import { getDifferenceInTime } from '@/helpers/DateTimeParser'
import { useInterval } from '@/hooks/useInterval'

interface TimeTickerProps {
    from: string
}

// Shows the time that passed since `from`, updated every second
export const TimeTicker: FC<TimeTickerProps> = ({ from }): ReactElement => {
    const [time, setTime] = useState(getDifferenceInTime(new Date(from), undefined, true))

    useInterval(() => {
        setTime(getDifferenceInTime(new Date(from), undefined, true))
    }, 1000)

    return <>{time}</>
}
